<template>
  <div id="app">
    <div class="titlebox" v-if="!isMobile">
      <div class="titlecontent flex_layout">
        <div class="title flex_layout">基层透析服务能力提升</div>
        <div class="search flex_layout">
          <div>
            <el-input
              placeholder="请输入课程名称或讲师名称"
              clearable
              v-model="searchinput"
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <div class="login">
            <div v-if="!isLogin" @click="openLoginDialog">登录/注册</div>
            <div v-else>
              欢迎您，{{
                UserInfo.realname ? UserInfo.realname : UserInfo.username
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="iostitlebox" v-else>
      <div class="banner">
        <img src="https://gyyc-jctxpx.oss-cn-beijing.aliyuncs.com/public-image/banner-ios.jpg" alt="" />
      </div>
    </div>
    <div class="menu" ref="menu">
      <ul>
        <li
          v-for="(item, index) in menuList"
          :key="index"
          :class="{
            active: item.name == glName,
            userInfo: item.name == 'User',
          }"
        >
          <a @click="routerChange(item.name)">{{ item.text }}</a>
        </li>
        <!-- <li class="userInfo"><a>个人中心</a></li> -->
      </ul>
    </div>
    <div
      class="mobilelogin flex_layout"
      v-if="isMobile && !isLogin"
      @click="openLoginDialog"
    >
      登录/注册
    </div>
    <div
      :class="{
        mobilelogin: true,
        flex_layout: true,
        active: glName == 'User',
      }"
      v-if="isMobile&&isLogin"
      @click="routerChange('User')"
    >
      个人中心
    </div>
    <router-view
      @openLoginDialog="openLoginDialog"
      @openbindDialog="openbindDialog"
      :isWeChat="isWeChat"
    />
    <div class="footer">
      <footerCard :isMobile="isMobile"></footerCard>
    </div>
    <div class="banquan" v-if="footershow" style="color: #999">
      京ICP备2022011792
    </div>
    <el-dialog
      :title="needBindMobile?'绑定':'登录'"
      :visible.sync="dialogVisible"
      :width="isMobile ? '100%' : '30%'"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <LoginModule
        @closeDialogHandle="handleClose"
        :needBindMobile="needBindMobile"
        :isWeChat="isWeChat"
      ></LoginModule>
    </el-dialog>
  </div>
</template>

<script>
import { isWeChatBrowser } from "@/assets/js/common";
import footerCard from "../../components/footerCard.vue";
import { menuRouter } from "../../router/menu-router";
import LoginModule from "../../components/loginModule.vue";
import { hasToken } from "../../assets/js/storage";
export default {
  components: {
    footerCard,
    LoginModule,
  },
  data() {
    return {
      dialogVisible: false,
      isMobile: document.body.clientWidth < 540 ? true : false,
      searchinput: "",
      footershow: true,
      isUserPage: true,
      glName: "",
      menuList: [],
      isWeChat: isWeChatBrowser(),
      isLogin: hasToken(),
      wechat_ticket: "",
      UserInfo: {},
      needBindMobile: false,
    };
  },
  created() {
    console.log("当前登录状态:" + this.isLogin);
    this.filterMenuRoute();
    this.updateLayoutHandle();
  },
  mounted() {},
  watch: {
    $route(to) {
      localStorage.setItem("ActiveMenuName", to.path.split("/")[1]);
      this.updateLayoutHandle();
    },
  },
  methods: {
    updateLayoutHandle() {
      this.isLogin = hasToken();
      this.UserInfo = localStorage.getItem("UserInfo")
        ? JSON.parse(localStorage.getItem("UserInfo"))
        : "";
      this.glName = localStorage.getItem("ActiveMenuName")
        ? localStorage.getItem("ActiveMenuName")
        : "Home";
    },
    handleClose() {
      this.dialogVisible = false;
    },
    openbindDialog() {
      this.needBindMobile = true;
      this.dialogVisible = true;
    },
    openLoginDialog() {
      this.dialogVisible = true;
    },
    filterMenuRoute() {
      const menuList = menuRouter.map((item, i) => {
        return {
          id: i + 1,
          name: item.name,
          text: item.meta.title,
        };
      });
      this.menuList = menuList;
      if (this.isMobile) {
        this.menuList = menuList.filter((item) => item.name != "User");
      }
    },
    routerChange(RouterName) {
      if (RouterName === "User" && !this.isLogin) {
        this.$message.warning("请您先登录");
        return this.openLoginDialog();
      }
      this.glName = RouterName;
      this.$router.push({ name: RouterName });
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  .menu::-webkit-scrollbar {
    display: none;
  }
  .iostitlebox {
    .banner {
      height: 220px;
      background: #eee;
      cursor: pointer;
      width: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .titlebox {
    margin-bottom: 10px;
    background: #05258e;
    height: 80px;
    width: 100%;
    .titlecontent {
      height: 100%;
      width: 62%;
      margin: 0 auto;
      justify-content: space-between;
      .title {
        font-size: 30px;
        font-weight: bold;
        color: #ffffff;
      }
      ::v-deep .el-input__inner {
        background: #00000000;
        border-radius: 30px;
        width: 300px;
        color: #fff;
      }
      .login {
        color: #ffffff;
        font-size: 18px;
        cursor: pointer;
        margin-left: 50px;
      }
    }
  }
  .mobilelogin {
    background: #05258e;
    height: 50px;
    width: 100%;
    color: #ffffff !important;
    justify-content: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    border-top: 1px solid rgba(255, 255, 255, 0.07);
  }
  .active {
      text-decoration: none;
      background: #6f44a1;
      a {
        color: #ffffff !important;
      }
    }
  .menu {
    background: #05258e;
    height: 80px;
    width: 100%;
    
    @media screen and (max-width: 540px) {
      height: 50px;
      overflow-x: scroll;
      overflow-y: hidden;
    }
    ul {
      height: 100%;
      width: 62%;
      margin: 0 auto;
      position: relative;
      @media screen and (max-width: 540px) {
        width: max-content;
      }
      .userInfo {
        position: absolute;
        right: 0;
        top: 0;
      }
      li {
        display: inline-block;
        height: 100%;
        position: relative;
        a {
          cursor: pointer;
          background-color: #ffffff00;
          padding: 0px 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          text-align: center;
          height: 100%;
          color: #fff;
          @media screen and (max-width: 540px) {
            font-size: 13px;
            padding: 0 18px;
          }
        }
        span {
          cursor: pointer;
          position: absolute;
          right: 5px;
          bottom: 20px;
          width: 0px;
          height: 0px;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-top: 7px solid #fff;
        }
        .iosSpan {
          display: none;
          @media screen and (max-width: 540px) {
            display: block;
          }
        }
      }
    }
  }
  .footer {
    background: #f1f4fc;
  }
  .banquan {
    height: 60px;
    background-color: #1c1128;
    color: #ffffff;
    text-align: center;
    line-height: 60px;
    font-size: 16px;
    @media screen and (max-width: 540px) {
      height: 40px;
      line-height: 40px;
      font-size: 12px;
    }
  }
}
</style>
